import type { IconData } from '@stacksjs/iconify-core'

export const windowMaximize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 8h20v2H2z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h18a1 1 0 0 1 1 1v5H2V3a1 1 0 0 1 1-1\"/><path fill=\"currentColor\" d=\"M2 10h20v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default windowMaximize
